module.exports = __webpack_public_path__ + "static/media/mkc-food-products.5d05fb34.png";